import { localizationService } from '@shared-services/localization-service';
import React from 'react';
import styled from 'styled-components';
import { DesignStyle } from '../types';
import ArrowLeft from './icons/ArrowLeft';

const { str } = localizationService;

interface BackButtonProps {
    className?: string;
    text?: string;
    onClick: () => void;
}

const BackButton = ({
    onClick,
    className,
    text = str('ui.runtimessr.calbooking.back.button'),
}: BackButtonProps) => {
    return (
        <StyledBackButton
            data-auto='booker-back-button'
            className={className}
            onClick={onClick}
        >
            <ArrowLeft />
            <span>{text}</span>
        </StyledBackButton>
    );
};

export default BackButton;

const StyledBackButton = styled.button`
    && {
        display: flex;
        align-items: center;
        gap: 8px;

        font-weight: 550;
        font-size: 14px;
        line-height: 22px;
        letter-spacing: 0px;

        background: none;
        border: none;
        cursor: pointer;
        color: #272b35;

        .${DesignStyle.SITE_THEME} & {
            color: var(--color_1);
        }
    }
`;
